import { CLOSE, SCREEN } from './constants';

export var access_token = '';

export var isOpenWidget = false;
export var currentScreen = SCREEN.DASHBOARD;
export var preScreen = null;
export var procedures = [];
export var procedureId = null;
export var countriesConsult = CLOSE;
export var countriesAskQs = CLOSE;
export var countriesPhone = CLOSE;
export var selectedCountry = 'US';
export var selectedCodeNumber = '1';
export var categories = [];
export var redirectUrl = '';
// Per-Calendar (appointment_channel) redirect after a fresh booking succeeds.
// Distinct from `redirectUrl` above, which is the widget-level thank-you redirect
// used immediately on the consult-form THE_END screen.
export var calendarRedirectUrl = '';
export var webAssistantOptions = [];
export var selectedProcedures = [];
export var selectedAddons = [];
export var createdLoader = false;
export var providers = [];
export var originProviders = [];
export var originProcedures = [];
export var providerId = '';
// True when the visitor explicitly picked the "No preference" option on the
// consult provider dropdown (consult_allow_no_preference). providerId stays
// empty in that case, so this flag is what distinguishes a deliberate
// "No preference" from "nothing selected yet".
export var noPreferenceSelected = false;
export var faqQuestions = [];
export var primaryColor = '';
export var tooltip = '';
export var picture = '';
export var locations = [];
export var locationId = '';
export var scheduling = 0;
export var selectedLocation = '';
export var selectedCategoryId = '';
export var emailOptin = false;
export var phoneToCall = '';
export var form = {};
export var optionNames = {};
export var optionIcons = {};
export var widgetOptions = [];
export var formId = '';
export var staffId = 0;
export var appUrl = '';
export var patientType = '';
export var procedureSelectionType = '';
export var startTime = 0;
export var endTime = 0;
export var providerServiceSummary = {};
export var selectedTime = {};
export var leadInfo = null;
export var sourceParam = '';
export var visitorId = '';
export var selectedInterest = '';
export var interests = [];
export var fullName = '';
export var email = '';
export var emailCheck = false;
export var phone = '';
export var estimateInfo = {};
export var isInInstantQuote = false;
export var surgicalOption = null;
export var isBookAppointment = false;
export var limitRightCarousel = 0;
export var pagesDom = [];
export var appointmentDateRange = {};
export var currentDateInUse = 0;
export var carouselCountLeft = 0;
export var isClickCheckBox = false;
export var isOTPTimeOut = true;
export var selectedAppointmentUnixTime = '';
export var appointmentSummary = {};
export var eventPayload = {};
export var eventId = null;
export var appointmentDuration = 0;
export var leadTextId = null;
export var customField = {};
export var customFields = [];
export var fileUploadChannel = [];
export var financing = [];
export var nameScreenDynamic = '';
export var firstLoadCustomFields = false;
export var listDataQuestion = {};
export var listNamePageQuestion = [];
export var firstQuestion = false;
export var appointmentQuestionsCompleted = false;
export var questionnaireFields = null;
export var questionnaireFormId = null;
export var selectedDateElement = null;
export var selectedDatetime = null;
export var selectedGender = null;
export var eventRoom = null;
export var consultationNonSurgicalPath = null;
export var businessName = '';
export var requestsGetSlotsTime = [];
export var nextRequestsGetSlotsTime = [];
export var showMaleFemalePage = false;
export var progressQuestion = {};
export var staffProcedures = null;
export var dataSlot = {};
export var hidePricing = false;
export var skipInterestPage = false;
export var hideFutureSpecialsOptIn = false;
export var showBodyAreaSelection = false;
export var bodyAreaSelected = [];
export var isModalPopup = false;
export var hasLead = false;
export var projectId = null;
export var patientSelected = null;
// Selected delivery mode ('virtual' | 'in_person') when the appointment channel
// has delivery_mode_selection on. Null until the visitor picks on the new step.
export var selectedDeliveryMode = null;
export var procedureIdSelected = null;
export var isDesktopVer = false;
export var appointmentChannelId = null;
export var proceduresOfAppointmentChannel = null;
export var showSubscribedToOffersOption = null;
export var selectedStaffAppointmentChannel = null;
export var isCheckedNote = false;
export var a2pConsentEnabled = false;
export var smsConsentTransactional = false;
export var smsConsentPromotional = false;
export var termsAndPrivacyAccepted = false;
export var isDisableSearchService = false;
export var isHiddenOnMobile = false;
export var isHiddenOnDesktop = false;
export var selectedLocationId = null;
export var isHiddenPoweredBy = false;
export var isWhitelabel = false;
export var isHideServiceDuration = false;
export var hiddenPages = [];
export var selectedLanguage = 'en';
export var shouldCollectPatientInfoFirstForWidget = false;
export var isFlowForCalendar = false;
export var assignedStaffId = null;
export var initUI = 'floater';
export var tempLeadInfo = null;

export function setVisitorId(val) {
    visitorId = val;
}

export function setTooltip(val) {
    tooltip = val;
}

export function setPicture(val) {
    picture = val;
}

export function setSourceParam(val) {
    sourceParam = val;
}

export function setLeadInfo(val) {
    leadInfo = val;
}

export function setAppointmentQuestionsCompleted(val) {
    appointmentQuestionsCompleted = val;
}

export function setQuestionnaireFields(val) {
    questionnaireFields = val;
}

export function setQuestionnaireFormId(val) {
    questionnaireFormId = val;
}

export function clearQuestionnaireContext() {
    questionnaireFields = null;
    questionnaireFormId = null;
}

export function setSelectedTime(val) {
    selectedTime = val;
}

export function setProviderServiceSummary(val) {
    providerServiceSummary = val;
}

export function setTime(start, end) {
    startTime = start;
    endTime = end;
}

export function setProcedureSelectionType(val) {
    procedureSelectionType = val;
}

export function setPatientType(val) {
    patientType = val;
}

export function setAppUrl(val) {
    appUrl = val;
}

export function setFormId(val) {
    formId = val;
}

export function setStaffId(val) {
    staffId = val;
}

export function setIsOpenWidget(val) {
    isOpenWidget = val;
}

export function setCurrentScreen(val) {
    currentScreen = val;
}

export function setPreScreen(val) {
    preScreen = val;
}

export function setProcedures(val) {
    procedures = val;
}

export function setRedirectUrl(val) {
    redirectUrl = val;
}

export function setCalendarRedirectUrl(val) {
    calendarRedirectUrl = val;
}

export function getCalendarRedirectUrl() {
    return calendarRedirectUrl;
}

export function setCategories(val) {
    categories = val;
}

export function setWebAssistantOptions(val) {
    webAssistantOptions = val;
}

export function setSelectedProcedures(val) {
    selectedProcedures = val;
}

export function setSelectedAddons(val) {
    selectedAddons = val;
}

export function setCountriesConsult(val) {
    countriesConsult = val;
}

export function setCountriesAskQs(val) {
    countriesAskQs = val;
}

export function setCountriesPhone(val) {
    countriesPhone = val;
}

export function setSelectedCountry(val) {
    selectedCountry = val;
}

export function setSelectedCodeNumber(val) {
    selectedCodeNumber = val;
}

export function setProcedureId(val) {
    procedureId = val;
}

export function setCreatedLoader(val) {
    createdLoader = val;
}

export function setProviders(val) {
    providers = val;
}

export function setOriginProviders(val) {
    originProviders = val;
}

export function setOriginProcedures(val) {
    originProcedures = val;
}

export function setProviderId(val) {
    providerId = val;
}

export function setNoPreferenceSelected(val) {
    noPreferenceSelected = val;
}

export function setQuestions(val) {
    faqQuestions = val;
}

export function setPrimaryColor(val) {
    primaryColor = val;
}

export function setLocations(val) {
    locations = val;
}

export function setInterests(val) {
    interests = val;
}

export function setLocationId(val) {
    locationId = val;
}

export function setScheduling(val) {
    scheduling = val;
}

export function setSelectedLocation(val) {
    selectedLocation = val;
}

export function setSelectedCategoryId(val) {
    selectedCategoryId = val;
}

export function setSelectedInterest(val) {
    selectedInterest = val;
}

export function setEmailOptin(val) {
    emailOptin = val;
}

export function setPhoneToCall(val) {
    phoneToCall = val;
}

export function setForm(val) {
    form = val;
}

// When the channel is set to auto-select the soonest provider, the widget skips
// the provider-selection step entirely and books via the existing "any provider"
// (-1) path, so the server auto-assigns the soonest-available provider per slot.
// Only meaningful when more than one bookable provider exists (with a single
// provider the existing single-select auto-skip already handles it).
// When auto_select_soonest_provider_new_patients_only is ALSO set, the skip is
// scoped to visitors who answered "new patient" — returning patients (or any
// state where the patient-type answer isn't a definite new_patient) keep the
// normal provider list, so the channel should pair it with
// show_any_provider_option for a "Soonest Available" row there.
export function isAutoSelectSoonestProviderEnabled() {
    const channel = form?.appointment_channel;
    if (!channel?.auto_select_soonest_provider) return false;
    if (channel?.auto_select_soonest_provider_new_patients_only && patientSelected !== 'new_patient') {
        return false;
    }
    const onlineStaff = channel?.staffs?.filter(
        (staff) => staff?.online_booking
    ) || [];
    return onlineStaff.length > 1;
}

export function setOptionNames(key, value) {
    optionNames[key] = value;
}

export function setOptionIcons(key, value) {
    optionIcons[key] = value;
}

export function setWidgetOptions(val) {
    widgetOptions = val;
}

export function setFullName(val) {
    fullName = val;
}

export function setEmail(val) {
    email = val;
}

export function setEmailCheck(val) {
    emailCheck = val;
}

export function setPhone(val) {
    phone = val;
}

/**
 * Name/email/phone the visitor TYPED in this widget, for the intake-form
 * handoff token. Never read off `leadInfo`: a contact match can bind the
 * booking to someone else's chart in the household.
 *
 * The info-first / consult form writes into `#nameConsult` / `#emailConsult`
 * / `#phoneConsult` and does not keep the module vars in sync, so those
 * inputs are the first source. Module vars cover the older dedicated
 * name/email/phone screens and anything we persisted after submit.
 */
export function typedIdentity() {
    const nameFromDom = (typeof document !== 'undefined'
        ? document.querySelector('#nameConsult')?.value
        : '') || '';
    const emailFromDom = (typeof document !== 'undefined'
        ? document.querySelector('#emailConsult')?.value
        : '') || '';
    const phoneFromDom = (typeof document !== 'undefined'
        ? document.querySelector('#phoneConsult')?.value
        : '') || '';

    const nameSource = (nameFromDom || fullName || '').trim();
    const emailSource = (emailFromDom || email || '').trim();
    const phoneSource = (phoneFromDom || phone || '').trim();
    const nameParts = nameSource.split(/\s+/).filter(Boolean);

    return {
        ...(nameParts[0] && { first_name: nameParts[0] }),
        ...(nameParts.length > 1 && { last_name: nameParts.slice(1).join(' ') }),
        ...(emailSource && { email: emailSource }),
        ...(phoneSource && { phone: phoneSource }),
    };
}

export function setEstimateInfo(val) {
    estimateInfo = val;
}

export function setIsInstantQuote(val) {
    isInInstantQuote = val;
}

export function setSurgicalOption(val) {
    surgicalOption = val;
}

export function setIsBookAppointment(val) {
    isBookAppointment = val;
}

export function setLimitRightCarousel(val) {
    limitRightCarousel = val;
}

export function addPagesDom(val) {
    pagesDom.push(val);
}

export function removeLastPagesDom() {
    pagesDom.pop();
}

export function resetPagesDom() {
    let temp = pagesDom[0];
    pagesDom.forEach((element) => {
        element.style.zIndex = '1';
    });
    pagesDom = [];
    temp.style.zIndex = '2';
    addPagesDom(temp);
}

export function setAppointmentDateRange(val) {
    appointmentDateRange = val;
}

export function setCurrentDateInUse(val) {
    currentDateInUse = val;
}

export function setCarouselCountLeft(val) {
    carouselCountLeft = val;
}

export function setIsClickCheckBox(val) {
    isClickCheckBox = val;
}

export function setIsOTPTimeOut(val) {
    isOTPTimeOut = val;
}

export function setSelectedAppointmentUnixTime(val) {
    selectedAppointmentUnixTime = val;
}

export function setAppointmentSummary(val) {
    appointmentSummary = val;
}

export function setEventPayload(val) {
    eventPayload = val;
}

export function setEventId(val) {
    eventId = val;
}
export function setAppointmentDuration(val) {
    appointmentDuration = val;
}

export function setLeadTextId(val) {
    leadTextId = val;
}

export function setCustomField(val) {
    customField = val;
}

export function setCustomFields(val) {
    customFields = val;
}

export function setFileUploadChannel(val) {
    fileUploadChannel = val;
}

/* Photos-first consult flow: set once the pre-questionnaire upload step is completed */
export var preQuestionnairePhotosDone = false;

export function setPreQuestionnairePhotosDone(val) {
    preQuestionnairePhotosDone = val;
}

export function setFinancing(val) {
    financing = val;
}

export function setNameScreenDynamic(val) {
    nameScreenDynamic = val;
}

export function setListDataQuestion(val) {
    listDataQuestion = val;
}

export function setListNamePageQuestion(val) {
    listNamePageQuestion = val;
}

export function setFirstQuestion(val) {
    firstQuestion = val;
}
export function setSelectedDateElement(val) {
    selectedDateElement = val;
}
export function setSelectedDatetime(val) {
    selectedDatetime = val;
}
export function setSelectedGender(val) {
    selectedGender = val;
}

export function setEventRoom(val) {
    eventRoom = val;
}

export function setConsultationNonSurgicalPath(val) {
    consultationNonSurgicalPath = val;
}

export function setBusinessName(val) {
    businessName = val;
}

export function setRequestsGetSlotsTime(val) {
    requestsGetSlotsTime = val;
}

export function setNextRequestsGetSlotsTime(val) {
    nextRequestsGetSlotsTime = val;
}

export function setShowMaleFemalePage(val) {
    showMaleFemalePage = val;
}

export function setProgressQuestion(val) {
    progressQuestion = val;
}

export function setStaffProcedures(val) {
    staffProcedures = val;
}

export function setDataSlot(val) {
    dataSlot = val;
}

export function setHidePricing(val) {
    hidePricing = val;
}

export function setShowBodyAreaSelection(val) {
    showBodyAreaSelection = val;
}

export function setBodyAreaSelected(val) {
    bodyAreaSelected = val;
}

export function setIsModalPopup(val) {
    isModalPopup = val;
}

export function setHasLead(val) {
    hasLead = val;
}

export function setProjectId(val) {
    projectId = val;
}

export function setPatientSelected(val) {
    patientSelected = val;
}

export function setSelectedDeliveryMode(val) {
    selectedDeliveryMode = val;
}

export function setAccessToken(val) {
    access_token = val;
}

export var otpAccessToken = null;
export function setOtpAccessToken(val) {
    otpAccessToken = val;
}

export function setProcedureIdSelected(val) {
    procedureIdSelected = val;
}

export function setIsDesktopVer(val) {
    isDesktopVer = val;
}

export function setAppointmentChannelId(val) {
    appointmentChannelId = val;
}

export function setProceduresOfAppointmentChannel(val) {
    proceduresOfAppointmentChannel = val;
}

// Location-scoped appointment channels link the same service once per location
// (appointment_channel_procedure.location_id, surfaced on each procedure as
// `location_id`). Without filtering, the service menu stacks every location's copy
// together (e.g. "Sick Visit" x3 for a 3-location channel). Given the chosen
// location, keep only that location's services plus any location-agnostic ones
// (location_id == null), collapsing residual duplicate ids. No-op for
// non-appointment-channel flows or channels whose procedures aren't location-scoped.
export function scopeProceduresToSelectedLocation(list) {
    if (!appointmentChannelId || !Array.isArray(list) || list.length === 0) {
        return list;
    }
    const hasLocationScoped = list.some((p) => p && p.location_id != null);
    if (!hasLocationScoped || !selectedLocation) {
        return list;
    }
    const locationId = parseInt(selectedLocation, 10);
    const matched = list.filter(
        (p) => p.location_id == null || parseInt(p.location_id, 10) === locationId
    );
    // Collapse residual duplicate service ids, preferring the location-specific row.
    const byId = new Map();
    for (const p of matched) {
        const existing = byId.get(p.id);
        if (!existing || (existing.location_id == null && p.location_id != null)) {
            byId.set(p.id, p);
        }
    }
    return Array.from(byId.values());
}

export function setShowSubscribedToOffersOption(val) {
    showSubscribedToOffersOption = val;
}

export function setSkipInterestPage(val) {
    skipInterestPage = val;
}

export function setHideFutureSpecialsOptIn(val) {
    hideFutureSpecialsOptIn = val;
}

export function setSelectedStaffAppointmentChannel(val) {
    selectedStaffAppointmentChannel = val;
}

export function setIsCheckedNote(val) {
    isCheckedNote = val;
}

export function setSmsConsentTransactional(val) {
    smsConsentTransactional = val;
}

export function setSmsConsentPromotional(val) {
    smsConsentPromotional = val;
}

export function setTermsAndPrivacyAccepted(val) {
    termsAndPrivacyAccepted = val;
}

export function setIsDisableSearchService(val) {
    isDisableSearchService = val;
}

export function setIsHiddenOnDesktop(val) {
    isHiddenOnDesktop = val;
}

export function setIsHiddenOnMobile(val) {
    isHiddenOnMobile = val;
}

export function setSelectedLocationId(val) {
    selectedLocationId = val;
}

export function setIsHiddenPoweredBy(val) {
    isHiddenPoweredBy = val;
}

export function setIsWhitelabel(val) {
    isWhitelabel = val;
}

export function setIsHideServiceDuration(val) {
    isHideServiceDuration = val;
}

export function setHiddenPages(val) {
    hiddenPages = val;
}

export function setSelectedLanguage(val) {
    selectedLanguage = val;
}

export function setShouldCollectPatientInfoFirstForWidget(val) {
    shouldCollectPatientInfoFirstForWidget = val;
}

export function setIsFlowForCalendar(val) {
    isFlowForCalendar = val;
}

export function setAssignedStaffId(val) {
    assignedStaffId = val;
}

export function setInitUI(val) {
    initUI = val;
}

export function setTempLeadInfo(val) {
    tempLeadInfo = val;
}

export function setA2pConsentEnabled(val) {
    a2pConsentEnabled = val;
}
